export function UploadIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12 22a1 1 0 001-1V9.414l5.293 5.293a1 1 0 001.414-1.414L12.71 6.296a.97.97 0 00-.319-.217.997.997 0 00-.388-.079H11.99a.997.997 0 00-.697.293l-7 7a1 1 0 101.414 1.414L11 9.414V21a1 1 0 001 1zM5 4a1 1 0 110-2h14a1 1 0 110 2H5z"
      ></path>
    </svg>
  );
}
